import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";

// Minimal query to count customers by usageTierId using the existing GSI
const CustomersByUsageTierIdsOnly = /* GraphQL */ `query CustomersByUsageTierIdAndNextReplenishAt(
  $usageTierId: ID!,
  $limit: Int,
  $nextToken: String
) {
  customersByUsageTierIdAndNextReplenishAt(
    usageTierId: $usageTierId,
    limit: $limit,
    nextToken: $nextToken
  ) {
    items { id }
    nextToken
  }
}`;

type CustomersIdsOnlyQuery = {
  customersByUsageTierIdAndNextReplenishAt?: {
    items?: Array<{ id: string } | null> | null;
    nextToken?: string | null;
  } | null;
};

export async function countCustomersForUsageTier(usageTierId: string): Promise<number> {
  let nextToken: string | null | undefined = undefined;
  const pageLimit = 1000; // use a large page size to minimize round trips
  let count = 0;

  do {
    const res = (await API.graphql(
      graphqlOperation(CustomersByUsageTierIdsOnly, {
        usageTierId,
        limit: pageLimit,
        nextToken,
      })
    )) as GraphQLResult<CustomersIdsOnlyQuery>;

    const items = res.data?.customersByUsageTierIdAndNextReplenishAt?.items ?? [];
    count += items.filter(Boolean).length;
    nextToken = res.data?.customersByUsageTierIdAndNextReplenishAt?.nextToken ?? null;
  } while (nextToken);

  return count;
}
